// Gatsby requirements
import React from 'react'

// Styles
import * as CSS from './SectionCta.module.scss'


const SectionCta = ({ content }) => {

    return (
        <div className={`
            ${CSS.section}
            ${'section' + content._uid}
        `}>

            {content?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    content.css.replaceAll('.section', '.section' + content._uid)
                }} />
            }

            <div>

                {content.pricePreviously && 
                    <span className={CSS.pricePreviously} aria-label={`Price previously: ${content.pricePreviously}`}>
                        {content.pricePreviously}
                    </span>
                }

                {content.priceNow && 
                    <span className={CSS.priceNow} aria-label={`Price now: ${content.priceNow}`}>
                        {content.priceNow}
                    </span>
                }

                {content.button && 
                    <a href={content.button.linkUrl} className="button" id={content.button?.buttonId}>
                        {content.button.buttonText}
                    </a>
                }

            </div>
        </div>
    )
}

export default SectionCta